import { connect } from "react-redux";
import PayoutDetails from "./PayoutDetails";
import { bindActionCreators } from "redux";
import { payoutDetailsWithId, updateAllPayoutDetails } from "services/redux/CarLoan/action";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    getAllThePayoutDetailsWithId : state.CarLoan.getAllThePayoutDetailsWithId,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    updatePayoutDetailsWithId: state.CarLoan.updatePayoutDetailsWithId,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        payoutDetailsWithId,
        documentUploadUrlPublic,
        updateAllPayoutDetails
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PayoutDetails);